export default __webpack_public_path__ + "static/IBMPlexSans-TextItalic-Latin1-bf098ce31366aaf268c492585e162cf4.woff2";